import React, { useState } from "react";
import { Box, Button, TextField, CircularProgress, Typography, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import { toast } from "react-toastify";
import api from "../../services/api";
import { getStoredUTMParams } from "../../utils/utmCapture";

const LeadCaptureForm = ({ landingPageId, primaryColor, buttonText }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [formData, setFormData] = useState({
        phone: "",
        name: "",
        email: ""
    });

    const handleOpen = () => {
        setOpen(true);
        setSuccess(false);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({ phone: "", name: "", email: "" });
        setSuccess(false);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.phone || formData.phone.trim().length === 0) {
            toast.error("Por favor, informe seu telefone");
            return;
        }

        setLoading(true);
        try {
            // Recuperar parâmetros UTM armazenados
            const utmParams = getStoredUTMParams() || {};

            // Enviar lead para backend
            await api.post("/campaign-leads", {
                landingPageId,
                phone: formData.phone,
                name: formData.name || null,
                email: formData.email || null,
                utmSource: utmParams.utmSource,
                utmMedium: utmParams.utmMedium,
                utmCampaign: utmParams.utmCampaign,
                utmContent: utmParams.utmContent,
                utmTerm: utmParams.utmTerm,
                gclid: utmParams.gclid,
                fbclid: utmParams.fbclid
            });

            setSuccess(true);
            toast.success("Obrigado! Entraremos em contato em breve.");

            // Limpar formulário após 3 segundos
            setTimeout(() => {
                handleClose();
            }, 3000);
        } catch (error) {
            console.error("Error submitting lead:", error);
            toast.error("Erro ao enviar seus dados. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                variant="contained"
                size="large"
                onClick={handleOpen}
                style={{
                    backgroundColor: primaryColor || "#6366f1",
                    color: "white",
                    padding: "15px 50px",
                    borderRadius: 30,
                    fontSize: 18,
                    fontWeight: 600,
                    textTransform: "none",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
                }}
            >
                {buttonText || "Começar Agora"}
            </Button>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {success ? "Sucesso!" : "Fale Conosco"}
                </DialogTitle>
                <DialogContent>
                    {success ? (
                        <Box textAlign="center" py={4}>
                            <CheckCircle style={{ fontSize: 80, color: "#4caf50", marginBottom: 20 }} />
                            <Typography variant="h6" gutterBottom>
                                Obrigado pelo seu interesse!
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                Entraremos em contato em breve.
                            </Typography>
                        </Box>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <Box py={2}>
                                <Typography variant="body2" color="textSecondary" gutterBottom>
                                    Preencha seus dados para que possamos entrar em contato
                                </Typography>

                                <TextField
                                    label="Telefone *"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    placeholder="(00) 00000-0000"
                                    required
                                    disabled={loading}
                                />

                                <TextField
                                    label="Nome"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    disabled={loading}
                                />

                                <TextField
                                    label="E-mail"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    disabled={loading}
                                />

                                <Box mt={3} display="flex" gap={2}>
                                    <Button
                                        onClick={handleClose}
                                        variant="outlined"
                                        fullWidth
                                        disabled={loading}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        fullWidth
                                        disabled={loading}
                                        style={{
                                            backgroundColor: primaryColor || "#6366f1",
                                            color: "white"
                                        }}
                                    >
                                        {loading ? <CircularProgress size={24} color="inherit" /> : "Enviar"}
                                    </Button>
                                </Box>
                            </Box>
                        </form>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default LeadCaptureForm;
